var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6293_2304)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 20,
    width: 50,
    height: 50,
    rx: 10,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6293_2304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3335 51.6667C39.4381 51.6667 40.3335 50.7713 40.3335 49.6667C40.3335 48.5622 39.4381 47.6667 38.3335 47.6667C37.2289 47.6667 36.3335 48.5622 36.3335 49.6667C36.3335 50.7713 37.2289 51.6667 38.3335 51.6667Z",
    fill: "#F3A8A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3333 33H37.6667C35.8992 33.0021 34.2047 33.7052 32.955 34.955C31.7052 36.2047 31.0021 37.8992 31 39.6667L31 50.3333C31.0021 52.1008 31.7052 53.7953 32.955 55.045C34.2047 56.2948 35.8992 56.9979 37.6667 57H56.3333C58.1008 56.9979 59.7953 56.2948 61.045 55.045C62.2948 53.7953 62.9979 52.1008 63 50.3333V39.6667C62.9979 37.8992 62.2948 36.2047 61.045 34.955C59.7953 33.7052 58.1008 33.0021 56.3333 33ZM37.6667 35.6667H56.3333C57.3942 35.6667 58.4116 36.0881 59.1618 36.8382C59.9119 37.5884 60.3333 38.6058 60.3333 39.6667H33.6667C33.6667 38.6058 34.0881 37.5884 34.8382 36.8382C35.5884 36.0881 36.6058 35.6667 37.6667 35.6667ZM56.3333 54.3333H37.6667C36.6058 54.3333 35.5884 53.9119 34.8382 53.1618C34.0881 52.4116 33.6667 51.3942 33.6667 50.3333V42.3333H60.3333V50.3333C60.3333 51.3942 59.9119 52.4116 59.1618 53.1618C58.4116 53.9119 57.3942 54.3333 56.3333 54.3333Z",
    fill: "#1B9075"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6293_2304",
    x: 0,
    y: 0,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6293_2304"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6293_2304",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6293_2304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(31 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.7f247b2b04e3b3b48e4c6f0812a98af6.svg";
export { ForwardRef as ReactComponent };